import React, {useContext} from 'react';
import UniversalButton from "../../uiComponents/UniversalButton";

import "./ProofModal.scss";
import {ModalContext} from "../../ModalContext";

const ProofModal = ({children, proofCallback, cancelButtonText, proofButtonText}) => {

  const { handleModal } = useContext(ModalContext);

  const handleCancel = () => {
    handleModal(null, true);
  };

  return (
    <div className="proof-modal">
      <div className="proof-modal__header">Are you sure?</div>
      <div className="proof-modal__text">{children}</div>

      <div className="radio-list-modal__btns">

        <div className="radio-list-modal__btns_btn">

          <UniversalButton
            type="button"
            label={cancelButtonText}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={handleCancel}
          />
        </div>

        <UniversalButton
          type="button"
          label={proofButtonText}
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={proofCallback}
        />
      </div>
    </div>
  );
};

export default ProofModal;